/* tslint:disable */
/* eslint-disable */
/**
 * InnerAnalytics MNT Server
 * InnerAnalytics MNT server API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ClinicianResponse } from '../models';
/**
 * ClinicianApi - axios parameter creator
 * @export
 */
export const ClinicianApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get currently logged in clinician info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiClinicianGetCurrentClinician: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/clinicians/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClinicianApi - functional programming interface
 * @export
 */
export const ClinicianApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClinicianApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get currently logged in clinician info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiClinicianGetCurrentClinician(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClinicianResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiClinicianGetCurrentClinician(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClinicianApi - factory interface
 * @export
 */
export const ClinicianApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClinicianApiFp(configuration)
    return {
        /**
         * 
         * @summary Get currently logged in clinician info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiClinicianGetCurrentClinician(options?: AxiosRequestConfig): AxiosPromise<ClinicianResponse> {
            return localVarFp.appApiClinicianGetCurrentClinician(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClinicianApi - object-oriented interface
 * @export
 * @class ClinicianApi
 * @extends {BaseAPI}
 */
export class ClinicianApi extends BaseAPI {
    /**
     * 
     * @summary Get currently logged in clinician info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicianApi
     */
    public appApiClinicianGetCurrentClinician(options?: AxiosRequestConfig) {
        return ClinicianApiFp(this.configuration).appApiClinicianGetCurrentClinician(options).then((request) => request(this.axios, this.basePath));
    }
}

